export default {
  'name': '默认调色板',
  'hide': false,
  'data': [
    {
      'id': '01',
      'name': 'White',
      'hex': '#FFFFFF'
    },
    {
      'id': '49',
      'name': 'Very Light Gray',
      'hex': '#E8E8E8'
    },
    {
      'id': '99',
      'name': 'Very Light Bluish Gray',
      'hex': '#E4E8E8'
    },
    {
      'id': '86',
      'name': 'Light Bluish Gray',
      'hex': '#AFB5C7'
    },
    {
      'id': '09',
      'name': 'Light Gray',
      'hex': '#9C9C9C'
    },
    {
      'id': '10',
      'name': 'Dark Gray',
      'hex': '#6B5A5A'
    },
    {
      'id': '85',
      'name': 'Dark Bluish Gray',
      'hex': '#595D60'
    },
    {
      'id': '11',
      'name': 'Black',
      'hex': '#212121'
    },
    {
      'id': '59',
      'name': 'Dark Red',
      'hex': '#6A0E15'
    },
    {
      'id': '05',
      'name': 'Red',
      'hex': '#B30006'
    },
    {
      'id': '167',
      'name': 'Reddish Orange',
      'hex': '#FF5500'
    },
    {
      'id': '231',
      'name': 'Dark Salmon',
      'hex': '#FF6326'
    },
    {
      'id': '25',
      'name': 'Salmon',
      'hex': '#FF7D5D'
    },
    {
      'id': '220',
      'name': 'Coral',
      'hex': '#FF8172'
    },
    {
      'id': '26',
      'name': 'Light Salmon',
      'hex': '#FCC7B7'
    },
    {
      'id': '58',
      'name': 'Sand Red',
      'hex': '#C58D80'
    },
    {
      'id': '120',
      'name': 'Dark Brown',
      'hex': '#50372F'
    },
    {
      'id': '168',
      'name': 'Umber',
      'hex': '#735442'
    },
    {
      'id': '08',
      'name': 'Brown',
      'hex': '#6B3F22'
    },
    {
      'id': '88',
      'name': 'Reddish Brown',
      'hex': '#82422A'
    },
    {
      'id': '91',
      'name': 'Light Brown',
      'hex': '#99663E'
    },
    {
      'id': '240',
      'name': 'Medium Brown',
      'hex': '#A16C42'
    },
    {
      'id': '106',
      'name': 'Fabuland Brown',
      'hex': '#B3694E'
    },
    {
      'id': '69',
      'name': 'Dark Tan',
      'hex': '#B89869'
    },
    {
      'id': '02',
      'name': 'Tan',
      'hex': '#EED9A4'
    },
    {
      'id': '90',
      'name': 'Light Nougat',
      'hex': '#FECCB0'
    },
    {
      'id': '241',
      'name': 'Medium Tan',
      'hex': '#FBC685'
    },
    {
      'id': '28',
      'name': 'Nougat',
      'hex': '#FFAF7D'
    },
    {
      'id': '150',
      'name': 'Medium Nougat',
      'hex': '#E3A05B'
    },
    {
      'id': '225',
      'name': 'Dark Nougat',
      'hex': '#CE7942'
    },
    {
      'id': '169',
      'name': 'Sienna',
      'hex': '#EA8339'
    },
    {
      'id': '160',
      'name': 'Fabuland Orange',
      'hex': '#EF9121'
    },
    {
      'id': '29',
      'name': 'Earth Orange',
      'hex': '#E6881D'
    },
    {
      'id': '68',
      'name': 'Dark Orange',
      'hex': '#B35408'
    },
    {
      'id': '27',
      'name': 'Rust',
      'hex': '#B24817'
    },
    {
      'id': '165',
      'name': 'Neon Orange',
      'hex': '#FA5947'
    },
    {
      'id': '04',
      'name': 'Orange',
      'hex': '#FF7E14'
    },
    {
      'id': '31',
      'name': 'Medium Orange',
      'hex': '#FFA531'
    },
    {
      'id': '32',
      'name': 'Light Orange',
      'hex': '#FFBC36'
    },
    {
      'id': '110',
      'name': 'Bright Light Orange',
      'hex': '#FFC700'
    },
    {
      'id': '172',
      'name': 'Warm Yellowish Orange',
      'hex': '#FFD788'
    },
    {
      'id': '96',
      'name': 'Very Light Orange',
      'hex': '#FFDCA4'
    },
    {
      'id': '161',
      'name': 'Dark Yellow',
      'hex': '#DD982E'
    },
    {
      'id': '173',
      'name': 'Ochre Yellow',
      'hex': '#D89905'
    },
    {
      'id': '03',
      'name': 'Yellow',
      'hex': '#FFE001'
    },
    {
      'id': '33',
      'name': 'Light Yellow',
      'hex': '#FEE89F'
    },
    {
      'id': '103',
      'name': 'Bright Light Yellow',
      'hex': '#FFF08C'
    },
    {
      'id': '236',
      'name': 'Neon Yellow',
      'hex': '#FFFC00'
    },
    {
      'id': '171',
      'name': 'Lemon',
      'hex': '#EDDC44'
    },
    {
      'id': '166',
      'name': 'Neon Green',
      'hex': '#DBF355'
    },
    {
      'id': '35',
      'name': 'Light Lime',
      'hex': '#ECEEBD'
    },
    {
      'id': '158',
      'name': 'Yellowish Green',
      'hex': '#E7F2A7'
    },
    {
      'id': '76',
      'name': 'Medium Lime',
      'hex': '#DFE000'
    },
    {
      'id': '34',
      'name': 'Lime',
      'hex': '#C4E000'
    },
    {
      'id': '248',
      'name': 'Fabuland Lime',
      'hex': '#ADD237'
    },
    {
      'id': '155',
      'name': 'Olive Green',
      'hex': '#ABA953'
    },
    {
      'id': '242',
      'name': 'Dark Olive Green',
      'hex': '#76753F'
    },
    {
      'id': '80',
      'name': 'Dark Green',
      'hex': '#2E5543'
    },
    {
      'id': '06',
      'name': 'Green',
      'hex': '#00923D'
    },
    {
      'id': '36',
      'name': 'Bright Green',
      'hex': '#10CB31'
    },
    {
      'id': '37',
      'name': 'Medium Green',
      'hex': '#91DF8C'
    },
    {
      'id': '38',
      'name': 'Light Green',
      'hex': '#D7EED1'
    },
    {
      'id': '48',
      'name': 'Sand Green',
      'hex': '#A2BFA3'
    },
    {
      'id': '39',
      'name': 'Dark Turquoise',
      'hex': '#00A29F'
    },
    {
      'id': '40',
      'name': 'Light Turquoise',
      'hex': '#00C5BC'
    },
    {
      'id': '41',
      'name': 'Aqua',
      'hex': '#BCE5DC'
    },
    {
      'id': '152',
      'name': 'Light Aqua',
      'hex': '#CFEFEA'
    },
    {
      'id': '63',
      'name': 'Dark Blue',
      'hex': '#243757'
    },
    {
      'id': '07',
      'name': 'Blue',
      'hex': '#0057A6'
    },
    {
      'id': '153',
      'name': 'Dark Azure',
      'hex': '#009FE0'
    },
    {
      'id': '247',
      'name': 'Little Robots Blue',
      'hex': '#5DBFE4'
    },
    {
      'id': '72',
      'name': 'Maersk Blue',
      'hex': '#7DC1D8'
    },
    {
      'id': '156',
      'name': 'Medium Azure',
      'hex': '#6ACEE0'
    },
    {
      'id': '87',
      'name': 'Sky Blue',
      'hex': '#8AD4E1'
    },
    {
      'id': '42',
      'name': 'Medium Blue',
      'hex': '#82ADD8'
    },
    {
      'id': '105',
      'name': 'Bright Light Blue',
      'hex': '#BCD1ED'
    },
    {
      'id': '62',
      'name': 'Light Blue',
      'hex': '#C8D9E1'
    },
    {
      'id': '55',
      'name': 'Sand Blue',
      'hex': '#8899AB'
    },
    {
      'id': '109',
      'name': 'Dark Blue-Violet',
      'hex': '#2032B0'
    },
    {
      'id': '43',
      'name': 'Violet',
      'hex': '#3448A4'
    },
    {
      'id': '97',
      'name': 'Blue-Violet',
      'hex': '#506CEF'
    },
    {
      'id': '245',
      'name': 'Lilac',
      'hex': '#7862CE'
    },
    {
      'id': '73',
      'name': 'Medium Violet',
      'hex': '#9391E4'
    },
    {
      'id': '246',
      'name': 'Light Lilac',
      'hex': '#CDCCEE'
    },
    {
      'id': '44',
      'name': 'Light Violet',
      'hex': '#C9CAE2'
    },
    {
      'id': '89',
      'name': 'Dark Purple',
      'hex': '#5F2683'
    },
    {
      'id': '24',
      'name': 'Purple',
      'hex': '#7A238D'
    },
    {
      'id': '93',
      'name': 'Light Purple',
      'hex': '#AF3195'
    },
    {
      'id': '157',
      'name': 'Medium Lavender',
      'hex': '#C689D9'
    },
    {
      'id': '154',
      'name': 'Lavender',
      'hex': '#D3BDE3'
    },
    {
      'id': '227',
      'name': 'Clikits Lavender',
      'hex': '#E0AAD9'
    },
    {
      'id': '54',
      'name': 'Sand Purple',
      'hex': '#B57DA5'
    },
    {
      'id': '71',
      'name': 'Magenta',
      'hex': '#B72276'
    },
    {
      'id': '47',
      'name': 'Dark Pink',
      'hex': '#EF5BB3'
    },
    {
      'id': '94',
      'name': 'Medium Dark Pink',
      'hex': '#F785B1'
    },
    {
      'id': '104',
      'name': 'Bright Pink',
      'hex': '#F7BCDA'
    },
    {
      'id': '23',
      'name': 'Pink',
      'hex': '#F5CDD6'
    },
    {
      'id': '56',
      'name': 'Rose Pink',
      'hex': '#F2D3D1'
    }
  ]
}
